import { NgModule } from '@angular/core';
import { AngularCollapseComponent } from './angular-collapse.component';

@NgModule({
  imports: [
  ],
  declarations: [AngularCollapseComponent],
  exports: [AngularCollapseComponent]
})
export class AngularCollapseModule { }
